import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const AdminLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0c162d 0%, #122240 50%, #0a192f 100%);
  padding: 20px;
`;

const LoginForm = styled.div`
  background: rgba(18, 34, 64, 0.6);
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 194, 255, 0.2);
  max-width: 400px;
  width: 100%;
`;

const LoginTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  color: #ffffff;
  font-size: 2rem;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #c4cdda;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid rgba(0, 194, 255, 0.3);
  background: rgba(18, 34, 64, 0.4);
  color: #ffffff;
  font-size: 1rem;
  
  &:focus {
    outline: none;
    border-color: #00c2ff;
    box-shadow: 0 0 0 2px rgba(0, 194, 255, 0.2);
  }
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(90deg, #00c2ff, #64ffda);
  color: #0c162d;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 194, 255, 0.4);
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  text-align: center;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 8px;
`;

const BackLink = styled.p`
  text-align: center;
  margin-top: 20px;
  color: #c4cdda;
  
  a {
    color: #64ffda;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Simple validation
    if (!username || !password) {
      setError('Please fill in all fields');
      return;
    }
    
    // For demo purposes, we'll use a simple check
    // In a real app, this would be an API call to authenticate
    if (username === 'admin' && password === 'admin123') {
      // Set admin authentication state
      localStorage.setItem('isAdminAuthenticated', 'true');
      // Redirect to admin dashboard
      navigate('/admin/dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <AdminLoginContainer>
      <LoginForm>
        <LoginTitle>Admin Login</LoginTitle>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="username">Username</Label>
            <Input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
            />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="password">Password</Label>
            <Input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </FormGroup>
          
          <LoginButton type="submit">Login</LoginButton>
        </form>
        
        <BackLink>
          <a href="/">Back to Website</a>
        </BackLink>
      </LoginForm>
    </AdminLoginContainer>
  );
};

export default AdminLogin;